import APIService from './APIService';

export default {
  getById(id) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(`/geo-perdas/servidores-bancos-dados/get-by-id/${id}`)
        .then((response) => {
          const { data: servidor } = response.data;
          resolve(servidor);
        })
        .catch((error) => reject(error));
    });
  },
  getServidores() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/geo-perdas/servidores-bancos-dados/get-all')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },
  save(postData) {
    return APIService.apiCall().post('/geo-perdas/servidores-bancos-dados/save', JSON.stringify(postData));
  },
  changeStatus(id) {
    return APIService.apiCall().patch(`/geo-perdas/servidores-bancos-dados/change-status/${id}`);
  },
  testConnection(postData) {
    return APIService.apiCall().post('/geo-perdas/servidores-bancos-dados/test-connection', JSON.stringify(postData));
  },
  showDatabases(postData) {
    return APIService.apiCall().post(`/geo-perdas/servidores-bancos-dados/show-databases`, JSON.stringify(postData));
  },
  getResumoEntidadesImportadas(id, database) {
    return APIService.apiCall().get(`/geo-perdas/servidores-bancos-dados/get-resumo-entidades-importadas/${id}/${database}`);
  },
  getStatusCamposCodBncEntidades(servidorId, database, bdgdVersaoId, entidades) {
    return APIService.apiCall().post(
      '/geo-perdas/servidores-bancos-dados/get-status-campos-cod-bnc-entidades',
      JSON.stringify({
        servidorId,
        database,
        bdgdVersaoId,
        entidades
      })
    );
  },
  baixarLinhasEntidadeComCodBncNulos(servidorId, database, bdgdVersaoId, entidade, config = {}) {
    return APIService.apiCall().post(
      '/geo-perdas/servidores-bancos-dados/baixar-linhas-entidade-com-cod-bnc-nulos',
      JSON.stringify({
        servidorId,
        database,
        bdgdVersaoId,
        entidade
      }),
      { responseType: 'blob', ...config }
    );
  }
};
